"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateAll = exports.RETRY_ERROR_TYPE = exports.MAX_RETRY_COUNT = exports.ChatCompletionError = exports.ErrorMessage = void 0;
exports.ErrorMessage = {
    NETWORK: "通信エラーです",
    BAD_REQUEST: "翻訳できない文字が含まれている可能性があります",
    UNKNOWN: "不明なエラーです",
    TIMEOUT: "Chat GPT エンジンの応答時間が長いためキャンセルしました",
    RATE_LIMIT: "Open AIのクオータ制限のため、秒待機してから再開します",
};
class ChatCompletionError extends Error {
    constructor(response) {
        super("ChatCompletionError");
        this.response = response;
    }
}
exports.ChatCompletionError = ChatCompletionError;
// Define the maximum number of parallel translation tasks
exports.MAX_RETRY_COUNT = 3;
exports.RETRY_ERROR_TYPE = ["NETWORK", "RATE_LIMIT"];
const PARALLEL = 3;
const DEFAULT_WAIT_TIME = 60;
// Function to translate all scripts with retry logic and parallel processing
const translateAll = (_a) => __awaiter(void 0, [_a], void 0, function* ({ scripts, translate, save, addError, langId, controller, }) {
    // Initialize the queue with the scripts to be translated
    const queue = [...scripts];
    // Function to remove and return the first script from the queue
    const pop = () => queue.shift();
    // Initialize workers for parallel processing
    const workers = [...Array(PARALLEL)].map(() => new TranslatorWorker(pop, () => queue, translate, save, addError, langId, controller));
    // Create promises for each worker to resolve when they finish processing
    const promises = workers.map((worker) => new Promise((resolve) => worker.on("empty", resolve)));
    // Start all workers
    workers.forEach((worker, index) => worker.startNoThrow(index));
    yield Promise.all(promises);
});
exports.translateAll = translateAll;
// TranslatorWorker class to handle translation tasks
class TranslatorWorker {
    constructor(pop, getQueue, translate, save, addError, langId, controller) {
        this.pop = pop;
        this.getQueue = getQueue;
        this.translate = translate;
        this.save = save;
        this.addError = addError;
        this.emptyCallbacks = [];
        this.finished = false;
        this.langId = langId;
        this.controller = controller;
    }
    startNoThrow(index) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let script;
            while ((script = this.pop())) {
                try {
                    // Handle timeout
                    const timeoutData = Object.assign(Object.assign({}, script), { error: "TIMEOUT" });
                    const timeoutPromise = new Promise((resolve, reject) => {
                        setTimeout(() => reject(timeoutData), 20000);
                    });
                    // Race the translation function against the timeout
                    const translated = yield Promise.race([
                        this.translate(script, this.controller),
                        timeoutPromise,
                    ]);
                    const { retryCount } = script, scriptWithoutRetry = __rest(script, ["retryCount"]);
                    const translatedScript = Object.assign(Object.assign({}, scriptWithoutRetry), { translations: {
                            [this.langId]: translated,
                        }, translationStatus: {
                            [this.langId]: "translated",
                        }, translationIgnore: {
                            [this.langId]: (_a = script === null || script === void 0 ? void 0 : script.translationIgnore) === null || _a === void 0 ? void 0 : _a[this.langId],
                        } });
                    // @ts-ignore
                    this.save(translatedScript);
                }
                catch (error) {
                    let errorType = "UNKNOWN";
                    if (error instanceof ChatCompletionError) {
                        const status = error.response.status;
                        if (status >= 500 && status < 600) {
                            errorType = "NETWORK";
                            console.error("Received a 5xx error in translateAll");
                            if (!script.retryCount || script.retryCount < exports.MAX_RETRY_COUNT) {
                                this.getQueue().push(Object.assign(Object.assign({}, script), { retryCount: (script.retryCount || 0) + 1 }));
                            }
                        }
                        else if (status === 429) {
                            errorType = "RATE_LIMIT";
                            const data = yield error.response.json();
                            const matcher = data.detail.message.match(/Please retry after (\d+) second/);
                            const timeToWait = matcher
                                ? parseInt(matcher[1], 10)
                                : DEFAULT_WAIT_TIME;
                            this.addError(Object.assign(Object.assign({}, script), { error: errorType, retryCount: ((script === null || script === void 0 ? void 0 : script.retryCount) || 0) + 1, timeToWait: timeToWait }));
                            console.error("Received a 429 error in translateAll", data);
                            if (!script.retryCount || script.retryCount < exports.MAX_RETRY_COUNT) {
                                // Wait for the specified time and then retry
                                yield new Promise((resolve) => setTimeout(resolve, timeToWait * 1000));
                                this.getQueue().push(Object.assign(Object.assign({}, script), { retryCount: ((script === null || script === void 0 ? void 0 : script.retryCount) || 0) + 1 }));
                            }
                        }
                        else if (status >= 400 && status < 500) {
                            console.error("Received a 4xx error in translateAll");
                            errorType = "BAD_REQUEST";
                        }
                        this.addError(Object.assign(Object.assign({}, script), { error: errorType }));
                    }
                    else if (error.error === "TIMEOUT") {
                        this.addError(error);
                    }
                    else {
                        this.addError(Object.assign(Object.assign({}, script), { error: errorType }));
                    }
                }
            }
            this.finished = true;
            this.emptyCallbacks.forEach((callback) => callback());
        });
    }
    on(event, callback) {
        if (event === "empty") {
            if (this.finished) {
                callback();
                return;
            }
            else {
                this.emptyCallbacks.push(callback);
            }
        }
    }
}
